var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 43",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "user",
    d: "M14.3 15.056v-1.507a3.935 3.935 0 0 0 1.41-2.224c.267-.02.686-.265.809-1.232a.881.881 0 0 0-.357-.9 3.987 3.987 0 0 0 .4-1.668c0-1.829-.718-3.391-2.26-3.391A2.4 2.4 0 0 0 12.042 3c-3.2 0-4.521 2.05-4.521 4.521a4.491 4.491 0 0 0 .4 1.668.882.882 0 0 0-.357.9c.124.967.542 1.212.809 1.232a3.935 3.935 0 0 0 1.41 2.224v1.507C9.028 17.316 3 15.809 3 21.083h18.083c0-5.274-6.028-3.767-6.783-6.027z",
    transform: "translate(-2 -2.084)",
    style: {
      fill: "#939393"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c1067a855787f46907b2d64fdbebfcb5.svg";
export { ForwardRef as ReactComponent };